import { Alert, Box, CircularProgress, Typography } from '@mui/material';
import type React from 'react';

interface Props {
  isLoading: boolean;
  title?: string;
}

const TransferProgressMessage: React.FC<Props> = ({
  isLoading,
  title = 'Processing Storage Change',
}) => {
  if (!isLoading) {
    return null;
  }

  return (
    <Box sx={{ mt: 2, mb: 2 }}>
      <Alert
        severity="warning"
        icon={<CircularProgress size={24} color="inherit" />}
        sx={{
          '& .MuiAlert-message': {
            width: '100%',
          },
        }}
      >
        <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
          {title}
        </Typography>
        <Typography variant="body2" paragraph>
          Your files are being transferred between storage providers. This process{' '}
          <strong>may take several minutes</strong> depending on the amount of data.
        </Typography>
        <Typography variant="caption" display="block" sx={{ fontWeight: 'bold' }}>
          ⚠️ Warning: Do not close this window or navigate away until the process is complete.
        </Typography>
      </Alert>
    </Box>
  );
};

export default TransferProgressMessage;
